module.exports = __webpack_public_path__ + "img/d0b08bb.jpg";